import { render, staticRenderFns } from "./QuantityFormulaScopes.vue?vue&type=template&id=845dd248&scoped=true"
import script from "./QuantityFormulaScopes.vue?vue&type=script&lang=js"
export * from "./QuantityFormulaScopes.vue?vue&type=script&lang=js"
import style0 from "./QuantityFormulaScopes.vue?vue&type=style&index=0&id=845dd248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845dd248",
  null
  
)

export default component.exports